"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var React = require("react");
var recompose_1 = require("recompose");
var sok_ui_1 = require("@caddigital/sok-ui");
var classNames = require("classnames");
require("./styles.scss");
exports.default = (0, recompose_1.pure)(function (props) { return (React.createElement(sok_ui_1.Modal, { className: classNames('fileupload-modal', props.hasCommentField && 'with-comment'), isOpen: props.isOpen },
    React.createElement(sok_ui_1.Header, { onClose: props.onRequestClose }, (0, translation_1.getLocalization)('userfront/project/files/genericFileUploadModal/uploadToSokoPro')),
    props.children)); });
